import React from 'react';
import { toast } from 'react-toastify';
import renderHTML from 'react-render-html';
import moment from 'moment';
import EventEmitter from './EventEmitter';
import * as Store from '../store'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class Utility {
    static toastNotifications = (message, title, type, autoclose = true, companyLogo = "", component = <></>) => {
        // Determine autoClose duration
        let _autoclose = autoclose === false ? false : (typeof autoclose === "number" ? autoclose : 3000);
        let errorToastId = "";
        let warningToastId = "";
        let callbackToastId = "";

        if (type === "success") {
            toast.success(
                <div className="tostify-inner-box">
                    <div className="iconbox">
                        <div className="alert_img">&nbsp;</div>
                    </div>
                    <div className="titleanddescriptionbox">
                        <h1>{title}</h1>
                        <div className="alert_box">
                            <div className="message_dec">{renderHTML(message)}</div>
                        </div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            }
            );
        } else if (type === "reminder") {
            toast.success(
                <div>
                    <h1>{title}</h1>
                    <div className="alert_box">
                        <div className="alert_img_reminder">&nbsp;</div>
                        <div className="message_dec">{renderHTML(message)}</div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false,
                closeOnClick: true
            }
            );
        } else if (type === "info") {
            toast.success(
                <div className="tostify-inner-box errorToastMsg">
                    <div className="iconbox">
                        <div className="alert_img_info">&nbsp;</div>
                    </div>
                    <div className="titleanddescriptionbox">
                        <h1 className="info_title_text">{title}</h1>
                        <div className="alert_box">
                            <div className="message_dec">{renderHTML(message)}</div>
                        </div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            }
            );
        } else if (type === "error") {
            errorToastId = message;
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="tostify-inner-box errorToastMsg">
                        <div className="iconbox">
                            <div className="alert_img_error">&nbsp;</div>
                        </div>
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                <div className="message_dec">{renderHTML(message)}</div>
                            </div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "warning") {
            warningToastId = message;
            if (!toast.isActive(warningToastId)) {
                toast.warning(
                    <div className="tostify-inner-box">
                        <div className="iconbox">
                            <div className="alert_img_warning">&nbsp;</div>
                        </div>
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                <div className="message_dec">{renderHTML(message)}</div>
                            </div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: false,
                    toastId: warningToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "longError") {
            errorToastId = message;
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="warning_message_box_long">
                        <div className="iconbox">
                            <div className="alert_img_warning">&nbsp;</div>
                        </div>
                        <h1 className="error_title">{title}</h1>
                        <div className="message_descriptipn error_title_dec">{renderHTML(message)}</div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: false,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                }
                );
            }
        } else if (type === "callback") {
            callbackToastId = message;
            if (!toast.isActive(callbackToastId)) {
                toast(component, {
                    position: toast.POSITION.TOP_LEFT,
                    transition: toast.slide,
                    toastId: callbackToastId,
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    closeButton: false
                });
            }
        }
    }

    static allRoute = () => {
        let routesUrl = [

        ];
        return routesUrl;
    }

    static toastNotificationsDismissAll = () => {
        toast.dismiss();
    }

    static displayNameFormat = (first_name = "", last_name = "") => {
        let concatname = first_name + " " + last_name
        return concatname
    }

    //role wise permission and userwise permission
    static roleWisePermission = (userId, visitorId, roleName) => {
        let permission = false;
        if (roleName == 'app_admin') {
            permission = true;
        } else {
            if (userId == visitorId) {
                permission = true;
            }
        }

        return permission;
    }

    static durationFormat = (num) => {
        let returnNumber = "";
        let durationCount = num.split('.');
        if (num == "0.50") {
            let nextDuration = durationCount[1].split("");
            returnNumber = "0." + nextDuration[0];
        } else {
            returnNumber = durationCount[0];
        }
        return returnNumber
    }

    static capitalizeFirstLetterOfEachWord(str) {
        // Split the string into words
        const words = str.split(/\s+/);
        // Capitalize the first letter of each word
        const capitalizedWords = words.map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            } else {
                return word; // If the word is empty, keep it as is
            }
        });
        // Join the words back into a string with spaces
        return capitalizedWords.join(' ');
    }

    static customDatePicker = () => {
        const myCustomLocale = {
            // months list by order
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],

            // week days by order
            weekDays: [
                {
                    name: 'Monday',
                    short: 'M',
                },
                {
                    name: 'Tuesday',
                    short: 'T',
                },
                {
                    name: 'Wednesday',
                    short: 'W',
                },
                {
                    name: 'Thursday',
                    short: 'T',
                },
                {
                    name: 'Friday',
                    short: 'F',
                },
                {
                    name: 'Saturday',
                    short: 'S',
                    isWeekend: true,
                },
                {
                    name: 'Sunday', // used for accessibility 
                    short: 'S', // displayed at the top of days' rows
                    isWeekend: true, // is it a formal weekend or not?
                }
            ],

            // just play around with this number between 0 and 6
            weekStartingIndex: 0,

            // return a { year: number, month: number, day: number } object
            getToday(gregorainTodayObject) {
                return gregorainTodayObject;
            },

            // return a native JavaScript date here
            toNativeDate(date) {
                return new Date(date.year, date.month - 1, date.day - 1);
            },

            // return a number for date's month length
            getMonthLength(date) {
                return new Date(date.year, date.month, 0).getDate();
            },

            // return a transformed digit to your locale
            transformDigit(digit) {
                return digit;
            },

            // texts in the date picker
            nextMonth: 'Next Month',
            previousMonth: 'Previous Month',
            openMonthSelector: 'Open Month Selector',
            openYearSelector: 'Open Year Selector',
            closeMonthSelector: 'Close Month Selector',
            closeYearSelector: 'Close Year Selector',
            defaultPlaceholder: 'Select...',

            // for input range value
            from: 'from',
            to: 'to',


            // used for input value when multi dates are selected
            digitSeparator: ',',

            // if your provide -2 for example, year will be 2 digited
            yearLetterSkip: 0,

            // is your language rtl or ltr?
            isRtl: false,
        }
        return myCustomLocale;
    }

    static currentMonthFirstDayLastDayFormat = () => {
        const currentDate = moment();
        const firstDayOfMonth = currentDate.clone().startOf('month');
        const lastDayOfMonth = currentDate.clone().endOf('month');
        const firstDayOfMonthString = firstDayOfMonth.format('YYYY-MM-DD');
        const lastDayOfMonthString = lastDayOfMonth.format('YYYY-MM-DD');
        let returnCurrentMonthFirstDayLastDay = {
            start_date: firstDayOfMonthString,
            end_date: lastDayOfMonthString,
        }
        return returnCurrentMonthFirstDayLastDay
    }

    static getRoleObjectByEventKey = (eventKey) => {
        let roleJsonData = Store.default.getState().LoginReducer.userCredentials.user_details.role_permission;
        let foundObject = JSON.parse(roleJsonData).find(item => item.eventKey === eventKey);
        return foundObject || {};
    }

    static getCurrencySymbol(currencyCode) {

        function identifyCurrency(value) {
            // Regular expression to match three-letter currency codes
            const currencyCodeRegex = /^[A-Z]{3}$/;

            // Check if the value matches the currency code regex
            if (currencyCodeRegex.test(value)) {
                return false;
            } else {
                return true;
            }
        }

        try {
            const locale = localStorage.getItem('i18nextLng') || 'en-US'; // Default to 'en-US' if locale is not available
            const formatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode,
            });
            const parts = formatter.formatToParts(1);
            const symbol = parts.find(part => part.type === 'currency')?.value;
            let symbolOrNot = identifyCurrency(symbol);
            if (!symbolOrNot) {
                switch (currencyCode) {
                    case 'AED':
                        return 'د.إ'; // UAE Dirham symbol
                    case 'BDT':
                        return '৳'; // Bangladeshi Taka symbol
                    default:
                        return symbol;
                }
            }

            return symbol;
        } catch (error) {
            return '';
        }
    }

    static calculateDaysNights(startDateStr, endDateStr) {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        const MS_PER_DAY = 24 * 60 * 60 * 1000; // milliseconds per day
        // Calculate the time difference in milliseconds
        const timeDifference = endDate.getTime() - startDate.getTime();
        // Calculate the number of days and nights
        const days = Math.floor(timeDifference / MS_PER_DAY) + 1;
        const nights = Math.ceil(timeDifference / MS_PER_DAY);
        return { days, nights };
    }


    static capitalizeOnlyFirstLetter = (str) => {
        if (!str || typeof str !== 'string') {
            return '';
        }

        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    static getTwoDecimalNumber(value) {
        let floatValue = parseFloat(value);
        if (isNaN(floatValue)) {
            floatValue = 0
        }
        return floatValue.toFixed(2)
    }

    static validateUPI(upiId) {
        // Regular expression pattern for UPI ID validation
        const upiRegex = /^[\w.-]+@[\w.-]+$/;

        // Check if the provided UPI ID matches the pattern
        return upiRegex.test(upiId);
    }

    static debounce = (func, delay) => {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }
    static debounceButton = (func, delay) => {
        let timeoutId;
        let lastArgs;
        let lastThis;

        const later = function () {
            func.apply(lastThis, lastArgs);
            lastThis = null;
            lastArgs = null;
        };

        return function () {
            lastThis = this;
            lastArgs = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(later, delay);
        };
    }

    static throttle(func, limit) {
        let inThrottle;
        return function () {
            const context = this;
            const args = arguments;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        };
    }

    static acceptFileType = () => {
        let fileType = ".jpg, .jpeg, .png"
        return fileType;
    }

    static checkFileType(file, allowedTypes) {
        const allowedTypesArray = allowedTypes.split(',').map(type => type.trim());
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const arr = new Uint8Array(reader.result.slice(0, 4));
                const header = Array.from(arr, byte => byte.toString(16).padStart(2, '0')).join('');
                const magicNumbers = {
                    'jpg': 'ffd8ffe0',
                    'jpeg': 'ffd8ffe1',
                    'png': ['89504e47', '0000001c']
                };
                for (let type of allowedTypesArray) {
                    const typeWithoutDot = type.replace('.', '');
                    const magicNumber = magicNumbers[typeWithoutDot];
                    if (Array.isArray(magicNumber)) {
                        if (magicNumber.includes(header)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    } else {
                        if (header.startsWith(magicNumber)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    }
                }

                let extension;
                switch (header) {
                    case "89504e47":
                        extension = "png";
                        break;
                    case "504b0304":
                        extension = "zip";
                        break;
                    case "52494646":
                        extension = "webp";
                        break;
                    case "47494638":
                        extension = "gif";
                        break;
                    case "ffd8ffe0":
                    case "ffd8ffe1":
                    case "ffd8ffe2":
                        extension = "jpg";
                        break;
                    default:
                        extension = "txt";
                }
                // If file type doesn't match any of the allowed types
                resolve({ isValid: false, fileType: extension });
            };
            reader.onerror = () => {
                reject("Error reading file");
            };
            // Read the file
            reader.readAsArrayBuffer(file);
        });
    }

    static hasNonZeroValues(input) {
        const numbers = input.split(',').map(Number);
        return numbers.some(num => num !== 0);
    }
    static getMonthName(monthNumber) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return months[monthNumber];
    }

    static bookingDateUi = (classNameCss, actualDate, inOutDate, type) => {
        let renderDate = actualDate;
        let tooltipText = null;

        if (inOutDate !== null) {
            const isDifferentDate = !moment(actualDate).isSame(inOutDate, 'day');
            tooltipText = isDifferentDate ? `Actual ${type} : \n ${moment(inOutDate.toString()).format('DD-MM-YYYY HH:mm')}` : null;
        }
        let colors = '#000000';
        colors = inOutDate !== null && tooltipText ? 'red' : '#000000';

        return (
            <div className={classNameCss}>
                {inOutDate === null ? (
                    <div style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</div>
                ) : (
                    tooltipText ? (
                        <OverlayTrigger overlay={<Tooltip>{tooltipText.split('\n').map((line, ind) => (
                            <div key={ind}>{line}</div>
                        ))}</Tooltip>}>
                            <span style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</span>
                        </OverlayTrigger>
                    ) : (
                        <span style={{ color: colors }}>{moment(renderDate.toString()).format('DD-MM-YYYY HH:mm')}</span>
                    )
                )}
            </div>
        );
    };

    static getCurrencyValue(value, currencyCode = 'INR') {
        let getSymbol = this.getCurrencySymbol(currencyCode);
        let floatValue = parseFloat(value);
        if (isNaN(floatValue)) {
            floatValue = 0;
        }
        return getSymbol + floatValue.toFixed(2);
    }
    static buildUrlParams(searchData) {
        const searchParams = new URLSearchParams();
        if (searchData.location) {
            searchParams.set('location', searchData.location);
        }
        if (searchData.type) {
            searchParams.set('type', searchData.type);
        }
        if (searchData.destination) {
            searchParams.set('destination', typeof searchData.destination === 'string' ?
                searchData.destination : Object.keys(searchData.destination).length > 0 ? searchData.destination.value : "");
        }
        if (searchData.start_date) {
            searchParams.set('startDate', moment(searchData.start_date).format('YYYY-MM-DD'));
        }
        if (searchData.end_date) {
            searchParams.set('endDate', moment(searchData.end_date).format('YYYY-MM-DD'));
        }
        if (searchData.adult) {
            searchParams.set('adult', searchData.adult);
        }
        if (searchData.children && searchData.children > 0) {
            searchParams.set('children', searchData.children);
            if (searchData.children_age && Array.isArray(searchData.children_age) && searchData.children_age.length > 0) {
                const childrenAges = [];
                searchData.children_age.forEach(childObj => {
                    if (childObj.age && childObj.age.value) {
                        childrenAges.push(childObj.age.value);
                    }
                });
                // Only add to URL if we have valid ages
                if (childrenAges.length > 0) {
                    searchParams.set('children_age', childrenAges.join(','));
                }
            }
        }

        // Add filter parameters to URL
        if (searchData?.filterData) {
            // Add property types
            if (searchData.filterData.property_type && searchData.filterData.property_type.length > 0) {
                // Check if property_type is an array before calling join
                if (Array.isArray(searchData.filterData.property_type)) {
                    searchParams.set('property_type', searchData.filterData.property_type.join(','));
                } else {
                    // Handle case when property_type is not an array
                    searchParams.set('property_type', searchData.filterData.property_type.toString());
                }
            }

            // Add amenities
            if (searchData.filterData.amenities && searchData.filterData.amenities.length > 0) {
                // Check if amenities is an array before calling join
                if (Array.isArray(searchData.filterData.amenities)) {
                    searchParams.set('amenities', searchData.filterData.amenities.join(','));
                } else {
                    searchParams.set('amenities', searchData.filterData.amenities.toString());
                }
            }

            // Add meals
            if (searchData.filterData.meals && searchData.filterData.meals.length > 0) {
                // Check if meals is an array before calling join
                if (Array.isArray(searchData.filterData.meals)) {
                    searchParams.set('meals', searchData.filterData.meals.join(','));
                } else {
                    searchParams.set('meals', searchData.filterData.meals.toString());
                }
            }

            // Add budget range
            if (searchData.filterData.budget_min !== undefined && searchData.filterData.budget_min !== "") {
                searchParams.set('budget_min', searchData.filterData.budget_min);
            }
            if (searchData.filterData.budget_max !== undefined && searchData.filterData.budget_max !== "" && searchData.filterData.budget_max > searchData.filterData.budget_min) {
                searchParams.set('budget_max', searchData.filterData.budget_max);
            }

            // Add property ratings
            if (searchData.filterData.property_rating && searchData.filterData.property_rating.length > 0) {
                // Check if property_rating is an array before calling join
                if (Array.isArray(searchData.filterData.property_rating)) {
                    searchParams.set('property_rating', searchData.filterData.property_rating.join(','));
                } else {
                    searchParams.set('property_rating', searchData.filterData.property_rating.toString());
                }
            }
        }
        return searchParams.toString();
    }
    static decodeUrlParams = (url) => {
        // Create a completely fresh search data object
        let searchData = {
            filterData: {
                // Initialize filter arrays with empty arrays by default
                property_type: [],
                amenities: [],
                meals: [],
                property_rating: []
            }
        };
        const searchParams = new URLSearchParams(url);

        if (searchParams.toString()) {
            // Extract all parameters from URL
            const destination = searchParams.get('destination');
            const type = searchParams.get('type');
            const location = searchParams.get('location');
            const startDate = searchParams.get('startDate');
            const endDate = searchParams.get('endDate');
            const adult = searchParams.get('adult');
            const children = searchParams.get('children');
            const children_age_param = searchParams.get('children_age');
            const property_type = searchParams.get('property_type');
            const amenities = searchParams.get('amenities');
            const meals = searchParams.get('meals');
            const budget_min = searchParams.get('budget_min');
            const budget_max = searchParams.get('budget_max');
            const property_rating = searchParams.get('property_rating');

            

            // Set minimal defaults for required fields
            searchData.children = 0; // Default to 0 children
            searchData.children_age = [];

            // Parse and set the destination
            if (destination) {
                // SearchPanel expects destination in a specific format
                // It could be a string or an object with value and label properties
                const decodedDestination = decodeURIComponent(destination);

                // Create destination in the format expected by SearchPanel component
                // This will ensure the dropdown selection appears correctly
                searchData.destination = decodedDestination;
            }
            if (type) {
                searchData.type = type;
            }
            if (location) {
                searchData.location = location;
            }
            // Parse and set dates
            if (startDate) {
                searchData.start_date = new Date(startDate);
            }

            if (endDate) {
                searchData.end_date = new Date(endDate);
            }

            // Parse and set guest counts
            if (adult) {
                searchData.adult = parseInt(adult);
            }

            if (children) {
                const childrenCount = parseInt(children);
                searchData.children = childrenCount;

                // Initialize children_age array with proper structure
                searchData.children_age = [];

                // Check for children_age parameter in URL
                if (children_age_param) {
                    // If ages are provided as comma-separated list
                    const decodedChildrenAge = decodeURIComponent(children_age_param);
                    const agesArray = decodedChildrenAge.includes(',') ?
                        decodedChildrenAge.split(',') : [decodedChildrenAge];

                    // Create the children_age array with proper structure that matches SearchPanel expectations
                    // SearchPanel expects: { age: { value: '2', label: '2 years' } }
                    for (let i = 0; i < Math.min(childrenCount, agesArray.length); i++) {
                        searchData.children_age.push({
                            age: {
                                value: agesArray[i],
                                label: agesArray[i] + ' years'
                            }
                        });
                    }

                    // If we have fewer ages than children, add empty ages
                    if (searchData.children_age.length < childrenCount) {
                        const remaining = childrenCount - searchData.children_age.length;
                        for (let i = 0; i < remaining; i++) {
                            searchData.children_age.push({ age: '' });
                        }
                    }
                } else {
                    // Check for individual child age parameters (children_age_0, children_age_1, etc.)
                    let foundIndividualAges = false;

                    for (let i = 0; i < childrenCount; i++) {
                        const childAgeParam = searchParams.get(`children_age_${i}`);
                        if (childAgeParam) {
                            foundIndividualAges = true;
                            searchData.children_age.push({
                                age: {
                                    value: childAgeParam,
                                    label: childAgeParam + ' years'
                                }
                            });
                        }
                    }

                    // If no individual ages found, initialize with empty ages
                    if (!foundIndividualAges) {
                        searchData.children_age = Array(childrenCount).fill({ age: '' });
                    } else if (searchData.children_age.length < childrenCount) {
                        // If we have fewer ages than children, add empty ages
                        const remaining = childrenCount - searchData.children_age.length;
                        for (let i = 0; i < remaining; i++) {
                            searchData.children_age.push({ age: '' });
                        }
                    }
                }
            }

            // Parse and set filters
            if (property_type) {
                // First decode the URL encoded string
                const decodedPropertyType = decodeURIComponent(property_type);
                // Then split by comma
                const propertyTypeArray = decodedPropertyType.includes(',') ?
                    decodedPropertyType.split(',') : [decodedPropertyType];

                // FilterPanel seems to expect property_type as a simple string or array of strings
                // Let's make sure it's in the right format
                searchData.filterData.property_type = propertyTypeArray;
            }

            if (amenities) {
                // First decode the URL encoded string
                const decodedAmenities = decodeURIComponent(amenities);
                // Then split by comma
                searchData.filterData.amenities = decodedAmenities.includes(',') ?
                    decodedAmenities.split(',') : [decodedAmenities];
            }

            if (meals) {
                // First decode the URL encoded string
                const decodedMeals = decodeURIComponent(meals);
                // Then split by comma
                searchData.filterData.meals = decodedMeals.includes(',') ?
                    decodedMeals.split(',') : [decodedMeals];
            }

            if (budget_min) {
                searchData.filterData.budget_min = parseInt(budget_min);
            }

            if (budget_max && budget_max > budget_min) {
                searchData.filterData.budget_max = parseInt(budget_max);
            }

            if (property_rating) {
                // First decode the URL encoded string
                const decodedPropertyRating = decodeURIComponent(property_rating);
                // Then split by comma
                searchData.filterData.property_rating = decodedPropertyRating.includes(',') ?
                    decodedPropertyRating.split(',') : [decodedPropertyRating];
            }
        }
        return searchData;
    }
}
/**
Adding a addDays method to Date object
*/
Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}
export default Utility;